import { render, staticRenderFns } from "./ParentField.vue?vue&type=template&id=39e322cc&scoped=true&"
import script from "./ParentField.vue?vue&type=script&lang=js&"
export * from "./ParentField.vue?vue&type=script&lang=js&"
import style0 from "./ParentField.vue?vue&type=style&index=0&id=39e322cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e322cc",
  null
  
)

export default component.exports